import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box"
import Container from "@mui/material/Container"

function HomePage(props){
    return (
        <Container maxWidth="100%">
            <Typography 
                variant="h1"
            >
                ...
            </Typography>
            <Box>
            </Box>
        </Container>
    );
};

export default HomePage;